export default {

  todaysSelfCheckIn(state) {
    return state.todaysSelfCheckIn;
  },

};
